import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getIconPath, getImageFilePath } from '@tcp/core/src/utils';
import CircularSpinner from './CircularSpinner.view';

const filterPlaceBucksCoupons = (coupons) =>
  coupons?.filter(({ offerType }) => offerType === 'PLACECASH');

const applyPlaceBuckCoupon = ({ availableCouponList, applyPlaceBucksCouponsAction }) => {
  const placeBuckCoupons = filterPlaceBucksCoupons(availableCouponList);
  const couponCodes = placeBuckCoupons.map(({ id }) => id);
  applyPlaceBucksCouponsAction(couponCodes);
};

const handleClick = ({ availableCouponList, applyPlaceBucksCouponsAction }) => {
  applyPlaceBuckCoupon({ availableCouponList, applyPlaceBucksCouponsAction });
};

const renderIcon = ({ multiAddCouponLoader, multiAddCouponSuccess }) => {
  if (multiAddCouponLoader) {
    return <CircularSpinner />;
  }

  const iconProps = multiAddCouponSuccess
    ? { width: '16px', height: '16px', src: getIconPath('circle-check-fill-green') }
    : {
        className: 'place-bucks-apply-icon',
        width: '10px',
        height: '6px',
        src: `${getImageFilePath()}/carrot-small-down.png`,
      };

  return <Image {...iconProps} />;
};

const MultipleCouponComponent = ({
  availableCouponList,
  applyPlaceBucksCouponsAction,
  multiAddCouponLoader,
  multiAddCouponSuccess,
  setMultiAddCpnSuccessAction,
  multiAddCouponErrorState,
  resetCouponError,
}) => {
  useEffect(() => {
    if (multiAddCouponSuccess) {
      const timer = setTimeout(() => {
        setMultiAddCpnSuccessAction(false);
      }, 1000);
      return () => clearTimeout(timer); // Cleanup timeout on component unmount
    }
    return () => {};
  }, [multiAddCouponSuccess, setMultiAddCpnSuccessAction]);

  useEffect(() => {
    resetCouponError(null);
    return () => {
      setMultiAddCpnSuccessAction(false);
    };
  }, []);
  return (
    <div className="apply-place-bucks-wrapper">
      <Button
        buttonVariation="fixed-width"
        className="apply-place-bucks-container"
        onClick={() => handleClick({ availableCouponList, applyPlaceBucksCouponsAction })}
        disabled={multiAddCouponLoader}
      >
        <BodyCopy
          className="left-content"
          component="span"
          fontSize="fs14"
          fontFamily="secondary"
          fontWeight="extrabold"
        >
          <Image
            className="elem-mr-XS_1"
            width="32px"
            height="32px"
            src={getIconPath('place-bucks')}
          />
          Apply Place Bucks
        </BodyCopy>
        {renderIcon({
          multiAddCouponLoader,
          multiAddCouponSuccess,
          availableCouponList,
          applyPlaceBucksCouponsAction,
        })}
      </Button>
      {multiAddCouponErrorState && (
        <BodyCopy
          className="error-message"
          component="span"
          fontSize="fs12"
          fontFamily="secondary"
          fontWeight="bold"
        >
          <Image
            className="elem-mr-XS_6 elem-mt-XXXS"
            width="12px"
            height="12px"
            src={getIconPath('circle-alert-fill')}
          />
          {multiAddCouponErrorState?.errorMessage}
        </BodyCopy>
      )}
    </div>
  );
};

MultipleCouponComponent.propTypes = {
  availableCouponList: PropTypes.isRequired,
  applyPlaceBucksCouponsAction: PropTypes.func.isRequired,
  multiAddCouponLoader: PropTypes.bool.isRequired,
  multiAddCouponSuccess: PropTypes.bool.isRequired,
  setMultiAddCpnSuccessAction: PropTypes.func.isRequired,
};

export default MultipleCouponComponent;
